import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import dayjs from "dayjs";
import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useReactToPrint } from "react-to-print";

const headerStyle = {
  p: 1,
  textAlign: "center",
  bgcolor: "#4527a0",
  color: "#FFF",
};
const cellStyle = {
  p: 0,
  textAlign: "center",
  border: "1px solid black",
};
function SalesReportPrint() {
  const { companyInfo } = useSelector((state) => state?.common);
  const logo = JSON.parse(companyInfo?.logo);
  const location = useLocation();
  const { tabledata, fromDate, toDate, godown, salesType } =
    location.state || {};
  const navigate = useNavigate();
  const componentRef = useRef();

  const columns = [
    // {
    //   headerName: "SINO",
    // },
    { headerName: "Date" },
    { headerName: "BillNo" },
    { headerName: "Customer Name" },
    { headerName: "Sub-Total" },
    { headerName: "Disc" },
    { headerName: "Tax" },
    { headerName: "Total Amt" },
  ];

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => {
      navigate(-2);
    },
  });
  useEffect(() => {
    handlePrint();
  }, [handlePrint]);

  const sumOfSubTotal = tabledata.reduce(
    (acc, cuu) => acc + (cuu.BillTotalField ?? 0),
    0
  );
  const sumOfDisc = tabledata.reduce(
    (acc, cuu) => acc + (cuu.BillDiscAmtField ?? 0),
    0
  );
  const sumOfTax = tabledata.reduce((acc, cuu) => acc + (cuu.TaxAmt ?? 0), 0);
  const sumOfNetTotal = tabledata.reduce(
    (acc, cuu) => acc + (cuu.BillNetTotalField ?? 0),
    0
  );

  console.log(dayjs(fromDate).format(), fromDate, toDate);

  return (
    <div ref={componentRef}>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Box px={2}>
          <Box
            component={"img"}
            sx={{ height: "auto", width: 120 }}
            src={logo?.img}
          />
        </Box>
        <Box>
          <Typography variant="h2" fontWeight={"bold"}>
            Sales Report
          </Typography>
          <Box>
            Date{" "}
            {`${fromDate} - ${toDate}`}
          </Box>

          <Box>
            Branch {godown}, Type {salesType}
          </Box>
        </Box>
        <Box px={2}>
          <Stack>
            <Typography textAlign={"center"} variant="h3">
              {companyInfo?.Name}
            </Typography>
            <Typography
              textAlign={"center"}
              variant="h5"
            >{`${companyInfo?.Add1} ${companyInfo?.Add2}`}</Typography>
            <Typography textAlign={"center"} variant="h5">
              {companyInfo?.Ph}
            </Typography>
            <Typography textAlign={"center"} variant="h5">
              {companyInfo?.city_name} {companyInfo?.Place}
            </Typography>

            <Typography textAlign={"center"} variant="h5">
              {companyInfo?.EMail}
            </Typography>
          </Stack>
        </Box>
      </Stack>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              {columns?.map((data, idx) => {
                return (
                  <TableCell sx={headerStyle} key={idx}>
                    {data.headerName}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {tabledata.map((data, idx) => (
              <TableRow key={idx}>
                {/* <TableCell sx={cellStyle}>{idx + 1}</TableCell> */}
                <TableCell sx={cellStyle}>{data?.BillDate}</TableCell>
                <TableCell sx={cellStyle}>{data?.BillNo}</TableCell>
                <TableCell sx={cellStyle}>{data?.BillPartyName}</TableCell>
                <TableCell sx={cellStyle}>{data?.BillTotalField?.toFixed(2)}</TableCell>
                <TableCell sx={cellStyle}>{data?.BillDiscAmtField?.toFixed(2)}</TableCell>
                <TableCell sx={cellStyle}>{data?.TaxAmt?.toFixed(2)}</TableCell>
                <TableCell sx={cellStyle}>{data?.BillNetTotalField?.toFixed(2)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableCell colSpan={3} sx={{ textAlign: "right" }}>
              {" "}
              <Typography fontWeight={600} variant="h5">
                Total
              </Typography>
            </TableCell>

            <TableCell sx={{ textAlign: "center" }}>
              <Typography fontWeight={600} variant="h5">
                {sumOfSubTotal.toFixed(2)}
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: "center" }}>
              <Typography fontWeight={600} variant="h5">
                {sumOfDisc.toFixed(2)}
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: "center" }}>
              <Typography fontWeight={600} variant="h5">
                {sumOfTax.toFixed(2)}
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: "center" }}>
              <Typography fontWeight={600} variant="h5">
                {sumOfNetTotal.toFixed(2)}
              </Typography>
            </TableCell>
          </TableFooter>
        </Table>
      </TableContainer>
    </div>
  );
}

export default SalesReportPrint;
